import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"icon-time\"><path d=\"M7.5 0C3.36 0 0 3.364 0 7.502c0 4.137 3.363 7.502 7.5 7.502 4.136 0 7.5-3.365 7.5-7.502C15 3.364 11.636 0 7.5 0Zm0 14a6.505 6.505 0 0 1-6.498-6.498A6.506 6.506 0 0 1 7.5 1.004a6.506 6.506 0 0 1 6.498 6.498A6.506 6.506 0 0 1 7.5 14Z\" fill=\"#00883F\" /><path d=\"M11.558 7H8.002V2.564a.503.503 0 0 0-1.006 0v4.939c0 .277.227.5.503.5h4.059a.502.502 0 1 0 0-1.004Z\" fill=\"#00883F\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol